import * as React from "react";

import DadosBasicosDetalhe from "./detalhe";
import { DadosBasicosBottom } from "./bottom";
import Utils from "../../helper/utils";
import { useTranslation } from "react-i18next";

export const DadosBasicosPage = () => {
  const { t } = useTranslation();
  Utils.setDocumentTitle(t("pages.basicData.titlePage"));

  return (
    <React.Fragment>
      <DadosBasicosDetalhe />
      <DadosBasicosBottom />
    </React.Fragment>
  );
};
